
import { defineComponent, PropType } from "vue";

import Company from "@/entities/domain/Company/Company";

import getImageFromSource from "@/utils/getImageFromSouce";
import addToStyling from "@/utils/AddToStyling";
import ChatbotWindowV3 from "@/components/Elements/Chatbot/ChatbotWindowV3.vue";

export default defineComponent({
	name: "ChatBotModePage",
	props: {
		company: {
			type: Object as PropType<Company>,
			required: true,
		},
	},
	data() {
		return {
			showBubble: false,
			bubbleWasOpened: false,
			focus: false,
			quizNeedsRefresh: false
		};
	},
	computed: {
		williTexts() {
			return this.company?.CompanyQuizConfig.ChatbotMode;
		},
		open(): boolean {
			return this.company?.CompanyQuizConfig.ChatbotMode?.QuizOnlyMode ?? false;
		},
	},
	watch: {
		showBubble: {
			handler(current: boolean) {
				addToStyling(`
					.ap-productfinder .tooltip::after{
						background-image: url("img/bubblearrow.svg");
					}
				`);
				if (current) this.bubbleWasOpened = true;
			},
			deep: true,
		},
	},
	mounted(){
		if(!this.company.CompanyQuizConfig.ChatbotMode?.QuizOnlyMode)
			this.$router.push("/question/" + this.company.Quiz.QuestionIdHistory[0]);

		setTimeout(() => {
			if (!this.showBubble && !this.bubbleWasOpened && this.company.CompanyQuizConfig.ChatbotMode?.QuizOnlyMode && this.company.CompanyQuizConfig.ChatbotMode?.SetNoticeAutomatically) {
				this.showBubble = true;

				if(this.company.CompanyQuizConfig.ChatbotMode.SetFocusAutomatically) this.focus = true;
			}
		}, 5000);

		// if Quiz is closed longer than thirty seconds, refresh quiz when opened
		setTimeout(() => {
			if (this.company.isQuizClosed) this.quizNeedsRefresh = true;
		}, 30000);
		
		addToStyling(`
			.ap-productfinder .tooltip::after{
				background-image: url("img/bubblearrow.svg");
			}
		`);
	},
	methods: {
		getImageFromSource,
		onFeatureWilliClick(): void {
			// TODO: Implement
		},
	},
	components: { ChatbotWindowV3 },
});
